import { createReducer, on } from '@ngrx/store';
import { InteractionId } from '../../../models';

import * as fromActions from './newrelic-interaction.actions';

export interface INewRelicInteractionState {
  interactionId: InteractionId;
}

export const initialState: INewRelicInteractionState = {
  interactionId: null,
};

export const newRelicInteractionReducer = createReducer(
  initialState,

  on(fromActions.SetNewRelicInteractionId, (state, { interactionId }) => {
    return {
      ...state,
      interactionId,
    };
  }),

  on(fromActions.ClearNewRelicInteractionId, state => {
    return {
      ...state,
      interactionId: null,
    };
  })
);

export const getNewRelicInteractionId = (state: INewRelicInteractionState) => state.interactionId;
